<template>
  <div>
     <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-table
            ref="table"
            gridHeight="750px"
            :columns="grid.columns"
            :data="grid.data"
            :editable="editable && data.checkStatusCd !== 'MCSC000015'"
            :gridHeightAuto="true"
            :columnSetting="false"
            :filtering="false"
            :usePaging="false"
          >
            <!-- 버튼 영역 -->
            <template v-slot:customArea="{ props, col }">
              <template v-if="col.name === 'customCol' && props.row['sopImprovementIds'] && props.row['ibmStepNames']">
                <q-chip
                  v-for="(item, index) in $comm.inspectIbmTagItems(props.row, colorItems, columnKey)"
                  :key="index"
                  :color="item.color"
                  :clickable="true"
                  text-color="white"
                  style="margin-bottom:4px !important;"
                  @click="linkClick(item, props.row)">
                  {{item.title}}
                  <c-assess-tooltip 
                    :ibmTooltip="item.ibmTooltip"
                    :ibmClassCd="item.ibmClassCd"
                  />
                </q-chip>
              </template>
              <div v-if="editable && data.safetyCheckId && !disabled && col.name === 'customCol'">
                <q-btn-group outline class="ColumInnerBtnGroup">
                  <q-btn
                    v-if="!disabled"
                    icon="add"
                    color="red-6"
                    text-color="white"
                    class="ColumInnerBtn"
                    align="center"
                    @click.prevent="innerBtnClicked(col, props, '1')">
                    <q-tooltip>
                      개선요청등록
                    </q-tooltip>
                  </q-btn>
                  <q-btn
                    v-if="!disabled"
                    icon="add"
                    color="light-blue"
                    text-color="white"
                    class="ColumInnerBtn"
                    align="center"
                    @click.prevent="innerBtnClicked(col, props, '2')">
                    <q-tooltip>
                      즉시조치등록
                    </q-tooltip>
                  </q-btn>
                </q-btn-group>
              </div>
              <template v-else>
                <c-select
                  stype="tableselect"
                  :editable="editable"
                  :comboItems="checkboxItems"
                  itemText="codeName"
                  itemValue="code"
                  type="edit"
                  label=""
                  name="checkItems"
                  v-model="props.row[col.name]"
                  @datachange="datachange2(props)"
                >
                </c-select>
              </template>
            </template>
            <template slot="table-header-append">
              <c-field
                :editable="editable"
                class="safetyCheckFieldSelect"
                style="min-width: 150px;max-width: 250px;padding-bottom: 0px !important"
                name="checkUserId"
                placeholder="점검자 선택"
                v-model="checkUserId">
              </c-field>
              &nbsp;&nbsp;
              <c-select
                v-if="editable && !disabled"
                :comboItems="dateItems"
                type="custom"
                typetxt="일자선택"
                itemText="dayName"
                itemValue="dayCode"
                name="today"
                label=""
                v-model="today"
                @datachange="datechange"
              ></c-select>
              &nbsp;&nbsp;
              <c-select
                v-if="editable && !disabled"
                :comboItems="afItems"
                type="none"
                itemText="afName"
                itemValue="afCode"
                name="today"
                label=""
                v-model="af"
                @datachange="datechange2"
              ></c-select>
            </template>
            <template slot="table-button">
              <q-btn-group>
                <c-btn
                  v-if="editable && !disabled"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data.safetyCheckId ? { 
                    safetyCheckResultModelList: data.safetyCheckResultModelList,
                    safetyCheckUserModel: {
                      dayId: this.columnKey,
                      safetyCheckId: this.popupParam.safetyCheckId, 
                      checkUserId: this.checkUserId
                    },
                  } : this.data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
          </c-table>
        </div>  
      </div>
      <c-dialog :param="popupOptions">></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
import mixinCommon from '@/js/mixin-page-common'
export default {
  name: 'safety-check-detail',
  mixins: [mixinCommon],
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        safetyCheckId: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    },
    eventScroll: {
      type: Object,
      default(){
        return {
          position: null,
          direction: null,
          save: null,
          isSave: false,
        }
      },
    },
  },
  data() {
    return {
      year: '',
      grid: {
        columns: [],
        data: [],
        height: 'auto',
      },
      data: {
        safetyCheckId: '',  // 열화점검 일련 번호
        plantCd: '',  // 사업장 코드
        checkStatusCd: '',  // 계획수립/점검중/점검완료
        checkDeptCd: '',  // 점검부서
        checkUserId: '',  // 점검자 ID
        checkDate: '',  // 점검월
        safetyCheckName: '',  // 점검명
        evaluationCompleteFlag: 'N',  // 결재완료 후 평가완료 처리
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드
        safetyCheckResultModelList: [], // sheet
        safetyCheckImproveModelList: [], // 개선 list
        safetyCheckUserModelList: [],
      },
      popupOptions: {
        isFull: true,
        // width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
      updateMode: false,
      editable: true,
      saveUrl: transactionConfig.sop.safetycheck.plan.insert.url,
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      isSave: false,
      isComplete: false,
      isApproval: false,
      mappingType: 'POST',
      getUrl: '',
      resultItemDetail: '',
      currentMonth: '',
      lunarHolidays: [],
      colorItems: [],
      checkboxItems: [],
      dateItems: [],
      today: null,
      afItems: [
        {afCode: 'A', afName: '주간'},
        {afCode: 'F', afName: '야간'}
      ],
      af: 'A',
      columnKey: '',
      userKey: '',
      checkUserId: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    mobileSave() {
      return {
        bol: this.editable && !this.disabled,
        uid: uid(),
      }
    },
    disabled() {
     return this.data.checkStatusCd === 'MCSC000015' || Boolean(this.data.sysApprovalRequestId)
    },
  },
  watch: {
    'eventScroll.save'() {
      this.saveData();
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      this.$comm.getStepItems('IBM_STEP_CD').then(_result => {
        this.colorItems = _result
      });


      this.today= this.$comm.getToday().slice(-2, this.$comm.getToday().length);
      this.currentMonth= this.$comm.getToday().slice(-5, this.$comm.getToday().length -3);
      if (String(this.today.charAt(0)) === '0') {
        this.today = this.today.substring(1)
      }

      this.columnKey = this.af === 'A' ? 'day' + this.today : 'nday' +this.today, 
      this.userKey = this.af === 'A' ? '' + this.today : this.today + 'n', 

      // url setting
      this.getUrl = selectConfig.sop.safetycheck.plan.get.url;
      this.insertUrl = transactionConfig.sop.safetycheck.plan.insert.url;
      this.updateUrl = transactionConfig.sop.safetycheck.result.newItem.url;
      // code setting
      // list setting
      this.search()
    },
    search() {
      this.getDetail();
    },
    setKey(data) {
      this.popupParam.safetyCheckId = data
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.safetyCheckId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.safetyCheckId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.data = _result.data;
          this.updateMode = true;
          
          if (this.$_.findIndex(_result.data.safetyCheckUserModelList, {dayId: this.columnKey}) !== -1) {
            let idx = this.$_.findIndex(_result.data.safetyCheckUserModelList, {dayId: this.columnKey});
            this.checkUserId = _result.data.safetyCheckUserModelList[idx].checkUserId;
          }
          this.setColumns();
        },);
      } 
    },
    setColumns() {
      this.$comm.getComboItems('MIN_SAFETY_RESULT_CD').then(_result => {
        this.checkboxItems = _result;
        let _columns = [
        {
          name: 'checkItemName',
          field: 'checkItemName',
          label: '점검항목',
          align: 'left',
          style: 'width:200px',
          sortable: false,
          fix: true,
        },
        {
          name: 'checkItemCycleName',
          field: 'checkItemCycleName',
          label: '주기',
          align: 'center',
          style: 'width:65px',
          sortable: false,
          fix: true,
        },
      ]
      let days = [];
      let year = this.data.checkDate.substring(0, 4);
      let month = this.data.checkDate.substring(5);

      let date = new Date(Number(year), Number(month), 0);

      for (let i=1; i<=date.getDate(); i++) {
        this.dateItems.push({
          dayName: i + '일',
          dayCode: String(i),
        })
      }
      let label = this.af === 'A' ? '주' : '야';
      if (this.data.checkDate) {
          days.push({
            name: this.columnKey,
            field: this.columnKey,
            label: this.today + '일('+label +')',
            currentDay: String(this.today) === String(this.today) && String(month) === String(this.currentMonth) 
                      ? true : false, 
            align: 'center',
            size: 'xs',
            setHeader: true,
            style: 'width:70px',
            comboItems: this.checkboxItems,
            headType: 'select',
            type: 'custom',
            sortable: false,
          })
          // days.push({
          //   name: 'nday' + this.today,
          //   field: 'nday' + this.today,
          //   label: '야',
          //   currentDay: String(this.today) === String(this.today) && String(month) === String(this.currentMonth) 
          //             ? true : false, 
          //   align: 'center',
          //   size: 'xs',
          //   setHeader: true,
          //   style: 'width:70px',
          //   headType: 'select',
          //   comboItems: this.checkboxItems,
          //   type: 'custom',
          //   sortable: false,
          // })

          this.grid.columns = this.$_.concat(_columns, days, {
            name: 'impr',
            field: 'impr',
            label: '개선진행',
            align: 'center',
            child: [
              {
                name: 'customCol',
                field: 'customCol',
                label: '개선번호/개선진행상태',
                align: 'center',
                style: 'width:200px',
                type: 'custom',
                sortable: false
              },
            ]
          });
          this.grid.data = this.$_.clone(this.data.safetyCheckResultModelList)
      }
          
      if (this.data.checkDate) {
        this.data.safetyCheckName = year + '년  ' + month + '월  관리감독자 안전점검일지'
      }
      })
    },
    saveData() {
      if (this.data.safetyCheckId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              
              this.data.safetyCheckResultModelList = this.$_.clone(this.grid.data);

              if (this.mappingType === 'POST') {
                this.popupParam.data.safetyCheckUserModelList.push({
                  dayId: this.popupParam.col.key,
                  safetyCheckId: this.popupParam.data.safetyCheckId, 
                  checkUserId: this.checkUserId,
                  editFlag: 'C',
                })
              }

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (this.mappingType === 'POST') {
        this.data.safetyCheckId = result.data
        this.returnData.col1 = result.data
        this.$_.forEach(this.grid.data, _item => {
          _item.safetyCheckId = result.data;
          _item.editFlag = 'U';
        })
        this.getDetail();
      } else {
        this.getDetail();
      }
    },
    datachange2(props) {
      if (props.row['editFlag'] !== 'C') {
        props.row['editFlag'] = 'U'
        props.row['chgUserId'] = this.$store.getters.user.userId
      }
    },
    datechange() {
      this.columnKey = this.af === 'A' ? 'day' + this.today : 'nday' +this.today; 
      this.userKey = this.af === 'A' ? '' + this.today : this.today + 'n';
      if (this.$_.findIndex(this.data.safetyCheckUserModelList, {dayId: this.columnKey}) !== -1) {
        let idx = this.$_.findIndex(this.data.safetyCheckUserModelList, {dayId: this.columnKey});
        this.checkUserId = this.data.safetyCheckUserModelList[idx].checkUserId;
      } else {
        this.checkUserId = ''
      }
      this.setColumns();
    },
    datechange2() {
      this.columnKey = this.af === 'A' ? 'day' + this.today : 'nday' +this.today;
      this.userKey = this.af === 'A' ? '' + this.today : this.today + 'n';
      
      if (this.$_.findIndex(this.data.safetyCheckUserModelList, {dayId: this.columnKey}) !== -1) {
        let idx = this.$_.findIndex(this.data.safetyCheckUserModelList, {dayId: this.columnKey});
        this.checkUserId = this.data.safetyCheckUserModelList[idx].checkUserId;
      } else {
        this.checkUserId = ''
      }
      
      this.setColumns();
    },
    innerBtnClicked(col, props, btn) {
      this.requestImprRow = props.row
      if (btn === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: props.row.checkItemName,
          relationTableKey: props.row.safetyCheckResultId+"/"+this.columnKey,
          ibmTaskTypeCd: 'ITT0000095'
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          requestContents: props.row.checkItemName,
          relationTableKey: props.row.safetyCheckResultId+"/"+this.columnKey,
          ibmTaskTypeCd: 'ITT0000095'
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      }
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.getDetail();
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;

      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.param = {
          sopImprovementId: data.sopImprovementId,
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
        this.popupOptions.width = '80%';
        this.popupOptions.visible = true;
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    closeImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getDetail();
    },
  }
};
</script>

<style lang="sass">
.safetyCheckFieldSelect
  .customDate
    padding-bottom: 0px !important
    .q-field__before
      padding-top: 5px
  .custom-text-before
    font-size:14px
    border: 1px solid rgba(0, 0, 0, 0.15) !important
    border-right: 0  !important
    border-radius: 4px 0 0 0
    line-height: 31px
    height: 33px !important
    min-height: 33px !important
  .custom-field
    .q-field__native
      cursor: pointer
  .q-field--dense .q-field__inner
    padding-bottom: 0px !important
  </style>